import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import {
  ThemeProvider,
  StyledEngineProvider,
  CssBaseline,
} from '@mui/material';
import { useEditorTheme } from './redux/editor/EditorHooks';

export const AppWithTheme = () => {
  const themeInUse = useEditorTheme();
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themeInUse}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
